import React from "react";
import { bindActionCreators } from "redux";
import { history } from "../../../store/configure/configureStore";
import { ModalView, ButtonView } from "../../controls";
import { getUnblock } from "../../../navigation/navigationBlocker";
import connect from "react-redux/es/connect/connect";
import {
  resetRowTags,
  resetShowSelection,
  resetNavigatingToOtherPageWarningModal,
  resetSelectedMultipleRows,
  resetRowCategory,
} from "../../../store/YouTubeManagement/YouTubeManagementActions";

import "./WarningDialogStyles.scss";

const WarningDialog = ({
  showWarningForRowTagsWhenNavigating,
  redirectingLink,
  //
  resetRowTags,
  resetRowCategory,
  resetShowSelection,
  resetSelectedMultipleRows, //reset the redux state of selected rows
  resetNavigatingToOtherPageWarningModal,
}) => {
  //--------------------------show Warning modal when navigation to different page using sidebar
  const renderNavigatingToOtherPageWarningBody = () => {
    return (
      <div className="body-content-wrapper warning-body">
        <div>
          All the selections and updated genres for the YouTube video will be
          lost.
        </div>
      </div>
    );
  };

  const renderNavigatingToOtherPageWarningFooter = () => {
    return (
      <div className="footer-wrapper">
        <div className="action-wrapper">
          <ButtonView
            title="Proceed"
            styles={"secondary"}
            // styles={"light"}
            size={"medium"}
            onClick={async () => {
              console.log("redirecting link", redirectingLink);

              await resetRowTags(); // Make sure these are async if you're using Redux Thunk
              await resetRowCategory();
              await resetShowSelection();
              await resetSelectedMultipleRows();
              await resetNavigatingToOtherPageWarningModal(); // Wait for the modal to reset

              getUnblock(); // Now unblock the navigation
              history.push(redirectingLink); // Finally, navigate
            }}
          />
        </div>
        <div className="action-wrapper">
          <ButtonView
            title="Cancel"
            styles={"light"}
            // styles={"light"}
            size={"medium"}
            onClick={() => {
              // handleCloseModal();
              resetNavigatingToOtherPageWarningModal();
            }}
          />
        </div>
      </div>
    );
  };

  return (
    <>
      <ModalView
        show={showWarningForRowTagsWhenNavigating}
        handleClose={() => {
          resetNavigatingToOtherPageWarningModal();
        }}
        center={true}
        showCloseIcon={true}
        title={"Attention"}
        size={"md"}
        children={renderNavigatingToOtherPageWarningBody()}
        footer={renderNavigatingToOtherPageWarningFooter()}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  showWarningForRowTagsWhenNavigating:
    state.youtubeManagement.showWarningForRowTagsWhenNavigating,
  redirectingLink: state.youtubeManagement.redirectingLink,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      resetRowTags,
      resetRowCategory,
      resetShowSelection,
      resetNavigatingToOtherPageWarningModal,
      resetSelectedMultipleRows,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(WarningDialog);
